import { c as _c } from "react/compiler-runtime";
// Works in both Next.js App Router (Server/Client Components) and Pages Router (SSR)
export function DateDisplay(t0) {
  const $ = _c(5);
  const {
    dateString
  } = t0;
  if (!dateString) {
    return null;
  }
  let t1;
  if ($[0] !== dateString) {
    const date = new Date(dateString);
    t1 = new Intl.DateTimeFormat("en-US", {
      dateStyle: "medium",
      timeZone: "UTC"
    }).format(date);
    $[0] = dateString;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedDate = t1;
  let t2;
  if ($[2] !== dateString || $[3] !== formattedDate) {
    t2 = <time suppressHydrationWarning={true} className="text-muted-foreground" dateTime={dateString}>{formattedDate}</time>;
    $[2] = dateString;
    $[3] = formattedDate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}